module.exports = __webpack_public_path__ + "static/img/shengji.86c8dd38.png";